module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAALGPC/xhBQAAARRJREFUOBFjZEAD/3cwaAOFUhj+M7gxMDLIgaX/MzwCsncB2XMYPRiuImthhHH+X2VgY3jM0AfUmAkUY4KJo9H/gAZNZ5BlKGLUZvgFkgMbANb8iGE7kO+EpgEXdx/QbZ4gQyA2gWzGplmhmIEBhDGBE9i1QHFGsJ//M1wCsjGdbXkGovW4CaYRDAwg7+iBNKVg1YxNC6oYWC8TOLRRJYjnAWOKCegMSFQRrw2hEqiXBcHDxvqHTRBFjAXohUdAES0UURjnTjOMhZ0G6gV5AZTCyANAvQSi8RTE4ONm2CyARCM4bYOSJzbwfCUDAwhjA0A9IL3UScrgjAFM28DwmAq0DF/Qg5w9FZYPQA6D50aYK0nNzgBMDU6PSFvd+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/CreateApp/images/warning.png
// module id = 3jYo
// module chunks = 1